export default __webpack_public_path__ + "static/media/bg1.9b675ad9.png";